import type { InfiniteData, UseInfiniteQueryResult } from '@tanstack/react-query';

import { ErrorMessage } from '@repo/types/messages/error';

import { EmptyState, EmptyStateContent, EmptyStateDescription, EmptyStateTitle } from '@/components/ui/empty-state';

import { SelectListElementSkeleton } from '.';

export interface SelectListInfiniteQueryStatesProps<T> {
  query: UseInfiniteQueryResult<InfiniteData<T, unknown> | undefined, Error>;
  isEmpty: boolean;
  noResults: boolean;
  errorMessage?: ErrorMessage;
  isEmptyMessage: string;
  noResultMessage: string;
}

export function SelectListInfiniteQueryStates<T>(selectListInfiniteQueryStatesProps: SelectListInfiniteQueryStatesProps<T>) {
  const {
    query: { isFetching, isError, isLoading, isFetchingNextPage },
    isEmpty,
    noResults,
    errorMessage,
    isEmptyMessage,
    noResultMessage,
  } = selectListInfiniteQueryStatesProps;

  return (
    <>
      {isEmpty && !isFetching && !isFetchingNextPage && (
        <EmptyState>
          <EmptyStateContent>
            <EmptyStateDescription>{isEmptyMessage}</EmptyStateDescription>
          </EmptyStateContent>
        </EmptyState>
      )}
      {noResults && !isFetching && !isFetchingNextPage && (
        <EmptyState>
          <EmptyStateContent>
            <EmptyStateDescription>{noResultMessage}</EmptyStateDescription>
          </EmptyStateContent>
        </EmptyState>
      )}
      {isError && (
        <EmptyState>
          <EmptyStateContent>
            <EmptyStateTitle>{errorMessage?.title}</EmptyStateTitle>
            <EmptyStateDescription>{errorMessage?.detail}</EmptyStateDescription>
          </EmptyStateContent>
        </EmptyState>
      )}

      {isLoading && (
        <>
          <SelectListElementSkeleton />
          <SelectListElementSkeleton />
        </>
      )}
    </>
  );
}
